// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IEntityTypeWrapper {
  format_version: string;
}
